<div onsip-grid-placement-shelf>
  <div class="first-column">
    <section>
      <div class="mat-body-1 m-b-12">Expansion module</div>
      <div>{{ expansionModuleName || "None" }}</div>
    </section>
  </div>
  <div class="second-column">
    <div class="lines-grid-title onsip-grid-placement">
      <span class="mat-body-1">Lines ({{ lines.length }} active)</span>
      @if (isPolycomPhone) {
      <span class="mat-body-1">Call waiting</span>
      }
    </div>
    @for (line of lines; track line) {
    <div class="lines-grid onsip-grid-placement">
      <div>
        <div class="mat-body-1">{{ line.line }}: {{ line.name }}</div>
        <div>({{ line.type }})</div>
      </div>
      @if(isPolycomPhone) {
      <div>{{ line.enabled }}</div>
      }
    </div>
    }
  </div>
</div>
<div class="page-view-controls">
  <button mat-flat-button class="toggle-button" color="primary" (click)="toggleLinePanel()">
    Edit Info
  </button>
</div>
